import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imLogo', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/auth/logo/logo.html'),
        controller: 'LogoController',
        controllerAs: 'LogoCtrl',
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/logo/logo.component.ts